"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryBoxPlot", {
  enumerable: true,
  get: function () {
    return _victoryBoxPlot.default;
  }
});

var _victoryBoxPlot = _interopRequireDefault(require("./victory-box-plot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/lib/index.js
// module id = 1848
// module chunks = 0